module.exports = __webpack_public_path__ + "img/senior_linkedin.f5ac641d.png";